const React = require('react')
const PropTypes = require('prop-types')
const log = require('log').create('video', 'vimeo') // eslint-disable-line

// vimeo example
// https://vimeo.com/260757651

function VimeoVideo({ video }) {
    const { type, video_id } = video
    if (type !== 'vimeo') return null
    if (! video_id) return null

    const src = `https://player.vimeo.com/video/${video_id}?title=0&byline=0&portrait=0/`
    return (
        <div className="video-wrapper vimeo">
            <iframe
                src={src}
                frameBorder="0"
                allowFullScreen={true}
                >
            </iframe>
        </div>
    )
}

VimeoVideo.propTypes = {
    video: PropTypes.object.isRequired,
}

module.exports = VimeoVideo
